<template>
  <div class="producto w-100">
    <div class="contenedor-producto" v-for="(item,index) in DetalleProducto" :key="index">
      <div class="portada-portafolio shadow">
        <div
          class="subportada-portafolio d-flex flex-wrap justify-content-center align-items-center"
        >
          <div>
            <h1 class="w-100">{{item.nombre}}</h1>
          </div>
        </div>
      </div>
      <!-- Titulo Principal -->
      <div class="contenedor">
        <div class="pt-5">
          <titulo-seccion>Descubre la mejor manera de administrar todos tus proyectos</titulo-seccion>
          <p class="mb-0 px-lg-5 pt-4">
            Nuestro sistema está capacitado con una amplia cantidad de características para optimizar
            las tareas de pequeñas y grandes empresas.
          </p>
        </div>
      </div>
      <!-- Fin Titulo Principal -->
      <!-- Imagenes -->
      <div class="contenedor">
        <div class="row justify-content-center align-items-center py-5">
          <div class="col-7">
            <img
              src="@/assets/images/productos/task/dashboard.jpeg"
              class="img-fluid rounded-lg shadow"
              alt="Dashboard"
              title="Dashboard"
            />
          </div>
          <div class="col-5 text-left">
            <div>
              <h3>Título</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore assumenda commodi sequi impedit ipsa,
                libero aliquid.
              </p>
            </div>
            <div>
              <h3>Título</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore assumenda commodi sequi impedit ipsa,
                libero aliquid.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="contenedor">
        <div class="row justify-content-center align-items-center py-5">
          <div class="col-5 text-left">
            <div>
              <h3>Un titulo :)</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore assumenda commodi sequi impedit ipsa,
                libero aliquid.
              </p>
            </div>
            <div>
              <h3>Otro más c:</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore assumenda commodi sequi impedit ipsa,
                libero aliquid.
              </p>
            </div>
          </div>
          <div class="col-7">
            <img
              src="@/assets/images/productos/task/dashboard.jpeg"
              class="img-fluid rounded-lg shadow"
              alt
              title
            />
          </div>
        </div>
      </div>
      <!-- Fin Imagenes -->
      <!-- Imagen -->
      <div class="contenedor">
        <div class="w-100 px-5 d-flex flex-wrap justify-content-center align-items-center py-5">
          <div>
            <titulo-seccion>Título</titulo-seccion>
            <p class="py-4">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore assumenda commodi sequi impedit ipsa,
              libero aliquid.
            </p>
          </div>
          <div>
            <img
              src="@/assets/images/productos/task/dashboard.jpeg"
              class="img-fluid rounded-lg shadow w-50"
              alt
              title
            />
          </div>
        </div>
      </div>
      <!-- Fin Imagen -->
      <!-- Caracteristicas -->
      <div class="contenedor">
        <div class="contenedor-caracteristicas py-5 row justify-content-center">
          <div class="col-12">
            <titulo-seccion>Integralo a tus proyectos</titulo-seccion>
            <p
              class="py-4"
            >Mejora el flujo de todos tus trabajos con las increíbles características de sus módulos</p>
          </div>
          <div class="caracteristica col-12 col-md-6 col-lg-4">
            <i class="fas fa-tasks icono icono-preventa"></i>
            <h1>Tareas</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia, ratione accusantium perferendis</p>
          </div>
          <div class="caracteristica col-12 col-md-6 col-lg-4">
            <i class="fas fa-history icono icono-venta"></i>
            <h1>Control de tiempo</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia, distinctio modi quis perferendis</p>
          </div>
          <div class="caracteristica col-12 col-md-6 col-lg-4">
            <i class="fas fa-file-alt icono icono-reportes"></i>
            <h1>Reportes</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia, ratione accusantium</p>
          </div>
        </div>
      </div>
      <!-- Fin Caracteristicas  -->
      <!-- Clientes Relacionados -->
      <div class="contenedor">
        <cliRelacionados
          class="contenedor-clientes py-5 borde-sombreado"
          img_width="220"
          :id_prod="item.id"
        />
      </div>
      <!-- Fin Clientes Relacionados -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "product",
  components: {},
  data() {
    return {
      DetalleProducto: []
    };
  },
  computed: {
    ...mapState(["Productos"])
  },
  created() {
    this.producto();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    producto() {
      this.Productos.forEach(item => {
        if (item.id == 4) {
          this.DetalleProducto.push(item);
        }
      });
    }
  }
};
</script>
<style scoped>
/* Portada */
.portada-portafolio {
  height: 60vh;
  width: 100%;
  color: white;
  background: #262626;
  background: url("https://cdn.pixabay.com/photo/2015/07/17/22/43/student-849825_960_720.jpg");
  background-size: cover;
}
.portada-portafolio h1 {
  font-size: calc(3.5em + 1vw);
  font-weight: bold;
  letter-spacing: -0.5px;
}
.portada-portafolio h1 {
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}
.subportada-portafolio {
  background: rgba(0, 0, 0, 0.23);
  height: 100%;
  width: 100%;
}
.contenedor{
  padding: 0 6%;
}
.contenedor-producto p,
.contenedor p {
  font-size: calc(0.9em + 0.3vw);
  color: #595959;
}
@media screen and (max-width: 768px) {
  .contenedor-producto p,
  .contenedor p {
    font-size: calc(1em + 0.3vw);
    color: #595959;
  }
  .portada-portafolio h1 {
    font-size: calc(2.8em + 1vw);
  }
}
/* Fin Portada */
/* Seccion Caracteristicas */
.contenedor-caracteristicas h1,
.titulo-objetivos {
  padding-top: 14px;
  font-size: calc(1.2em + 0.5vw);
  color: #262626;
}
.caracteristica p {
  margin-top: 0px;
  color: #595959;
  font-weight: 500;
  letter-spacing: -0.2px;
  font-size: calc(0.6em + 0.5vw);
  margin-bottom: 7px;
}
@media screen and (max-width: 768px) {
  .caracteristica p {
    font-size: calc(1em + 0.5vw);
  }
}
.caracteristica {
  margin-bottom: 20px;
}
.caracteristica .icono {
  border-radius: 200px;
  width: 76px;
  height: 76px;
  padding: 20px;
  color: white;
  -moz-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  background: #262626;
}
/* Fin Caracteristicas */
</style>
